import { useRef, useState } from "react";
import { Upload } from "lucide-react";

export default function UploadZone({ accept, onFile, label, hint, testId = "upload-zone" }) {
  const [dragging, setDragging] = useState(false);
  const [fileName, setFileName] = useState("");
  const inputRef = useRef(null);

  const handleFiles = (files) => {
    if (!files || !files.length) return;
    const f = files[0];
    setFileName(f.name);
    onFile(f);
  };

  return (
    <div
      data-testid={testId}
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => {
        e.preventDefault(); setDragging(false);
        handleFiles(e.dataTransfer.files);
      }}
      className={`cursor-pointer border-2 border-dashed p-10 sm:p-14 flex flex-col items-center justify-center text-center transition-colors ${
        dragging ? "border-black bg-[#3B82F6]/30" : "border-black/25 hover:border-black hover:bg-black/[0.03]"
      }`}
    >
      <div className="w-12 h-12 bg-black text-[#3B82F6] flex items-center justify-center mb-4">
        <Upload className="w-5 h-5" />
      </div>
      <p className="font-heading text-xl sm:text-2xl font-bold">{label}</p>
      {hint && <p className="mt-2 font-mono text-xs uppercase tracking-widest text-zinc-500">{hint}</p>}
      {fileName && (
        <p data-testid={`${testId}-filename`} className="mt-4 font-mono text-xs bg-black text-white px-3 py-1">
          {fileName}
        </p>
      )}
      <input
        ref={inputRef}
        data-testid={`${testId}-input`}
        type="file"
        accept={accept}
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
      />
    </div>
  );
}
